module.exports = {
	"pagination": {
		"DescribeReportDefinitions": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/cur-2017-01-06.paginators.json
// module id = 380
// module chunks = 0